import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var formatCache = {};
var fmtReg = /[0#.,]/;

var resolveFormat = function resolveFormat(pattern) {
  if (formatCache[pattern]) {
    return formatCache[pattern];
  }

  var prefix = [];
  var suffix = [];
  var withSign = false;
  var percent = 1; // 是否需要转化百分化或者千分化, 百分化为100, 千分化为1000

  var fmt = [];
  var ch = '';
  var state = 'PREFIX';
  var escape = false;
  var temp;

  function append(c) {
    if ('PREFIX' === state) {
      temp = prefix;
    } else if ('FMT' === state) {
      temp = fmt;
    } else {
      temp = suffix;
    }

    temp.push(c);

    if (escape) {
      return;
    }

    if ('PREFIX' === state && ['+', '-'].includes(c) && fmtReg.test(pattern[i + 1])) {
      temp.pop();
      withSign = true;
    }

    if (suffix.length === 1) {
      if (suffix[0] === '%') {
        percent = 100;
      } else if (suffix[0] === '‰') {
        percent = 1000;
      }
    }
  }

  function setState(c) {
    if (state === 'PREFIX' && fmtReg.test(c)) {
      state = 'FMT';
    } else if (state === 'FMT' && !fmtReg.test(c)) {
      state = 'SUFFIX';
    }
  }

  var i = 0;

  for (; i < pattern.length; i++) {
    ch = pattern[i];

    if (escape) {
      append(ch);
      escape = false;
      continue;
    }

    setState(ch);

    if (ch === '\\') {
      escape = true;
    } else {
      append(ch);
    }
  }

  prefix = prefix.join('');
  fmt = fmt.join('');
  suffix = suffix.join('');

  if (!fmt) {
    return formatCache[pattern] = {
      suffix: suffix,
      prefix: prefix,
      percent: percent,
      thousandSeparate: 3,
      withSign: withSign
    };
  }

  if (/\..*\./.test(fmt)) {
    throw Error("Multiple decimal separators in pattern \"".concat(pattern, "\""));
  }

  var _fmt$split = fmt.split('.'),
      _fmt$split2 = _slicedToArray(_fmt$split, 2),
      intFmt = _fmt$split2[0],
      _fmt$split2$ = _fmt$split2[1],
      decimalFmt = _fmt$split2$ === void 0 ? '' : _fmt$split2$;

  if (/[^0#]/.test(decimalFmt)) {
    throw Error("Malformed pattern \"".concat(pattern, "\""));
  }

  if (decimalFmt.includes('#0')) {
    throw Error("Unexpected '0' in pattern \"".concat(pattern, "\""));
  }

  if (intFmt.endsWith(',')) {
    throw Error("Malformed pattern \"".concat(pattern, "\""));
  }
  /* fmt只可能出现 #0., 四种符号,多个.的情况已经在前面排除，这里不需要这个if了
  if (/[^0#,]/.test(intFmt)) {
    throw Error(`Malformed pattern "${pattern}"`);
  }
  */


  if (/0.*#/.test(intFmt)) {
    throw Error("Unexpected '0' in pattern \"".concat(pattern, "\""));
  }

  var thousandSeparate = 0;
  var lastIndexOfSeperator = intFmt.lastIndexOf(',');

  if (lastIndexOfSeperator !== -1) {
    thousandSeparate = intFmt.length - lastIndexOfSeperator - 1;
  }

  var length = intFmt.replace(/,/g, '').match(/0*$/)[0].length;
  var maxScale = decimalFmt.length;
  var minScale = decimalFmt.match(/^0*/)[0].length;
  var radixPoint = fmt.endsWith('.');
  var config = {
    prefix: prefix,
    suffix: suffix,
    percent: percent,
    thousandSeparate: thousandSeparate,
    maxScale: maxScale,
    minScale: minScale,
    length: length,
    radixPoint: radixPoint,
    withSign: withSign
  };
  formatCache[pattern] = config;
  return config;
}; // 小数点右移


function enlarge(n, multi) {
  if (!multi) {
    return n;
  }

  if (multi < 0) {
    return shrink(n, -multi);
  }

  var num = "".concat(n).concat('0'.repeat(multi));
  return +num.replace(new RegExp("\\.(\\d{".concat(multi, "})")), '$1.');
} // 小数点左移


function shrink(n, multi) {
  if (!multi) {
    return n;
  }

  if (multi < 0) {
    return enlarge(n, -multi);
  }

  return +"".concat(n).replace(/^-?/, "$&".concat('0'.repeat(multi))).replace(new RegExp("(\\d{".concat(multi, "})(\\.|$)")), '.$1');
} // 防止1.005.toFixed(2) === 1.00 的问题出现


function adjust(n, scale) {
  var num = "".concat(n);

  if (num.includes('.')) {
    var arr = num.split('.');
    arr[1] = "".concat(arr[1].padEnd(scale, 0), "1");
    return +arr.join('.');
  } else {
    return n;
  }
}

function round(n, scale, roundingMode) {
  var _$split = "".concat(n).split('.'),
      _$split2 = _slicedToArray(_$split, 2),
      int = _$split2[0],
      decimal = _$split2[1];

  var sign = n > 0 ? '' : '-';

  if (!decimal) {
    return +n.toFixed(scale);
  } else {
    decimal = decimal.padEnd(scale + 1, 0);

    if (roundingMode === RoundingMode.CEILING) {
      return shrink(Math.ceil(enlarge(n, scale)), scale);
    } else if (roundingMode === RoundingMode.FLOOR) {
      return shrink(Math.floor(enlarge(n, scale)), scale);
    } else if (roundingMode === RoundingMode.UP) {
      return +"".concat(sign).concat(shrink(Math.ceil(enlarge(Math.abs(n), scale)), scale));
    } else if (roundingMode === RoundingMode.DOWN) {
      return +"".concat(sign).concat(shrink(Math.floor(enlarge(Math.abs(n), scale)), scale));
    } else if (roundingMode === RoundingMode.HALF_UP) {
      return +adjust(n, scale).toFixed(scale);
    } else if (roundingMode === RoundingMode.HALF_DOWN) {
      var decimalArr = decimal.split('');

      if (decimalArr[scale] == 5) {
        decimalArr[scale] = 1;
      }

      return +(+[int, decimalArr.join('')].join('.')).toFixed(scale);
    } else if (roundingMode === RoundingMode.HALF_EVEN) {
      var _decimalArr = decimal.split('');

      if (_decimalArr[scale] == 5) {
        var lastNum = _decimalArr[scale - 1] || int.slice(-1)[0];

        if (+lastNum % 2 === 0) {
          _decimalArr.splice(scale);
        } else {
          _decimalArr[scale] = 9;
        }
      }

      return +(+[int, _decimalArr.join('')].join('.')).toFixed(scale);
    } else if (roundingMode === RoundingMode.UNNECESSARY) {
      if (shrink(Math.ceil(enlarge(n, scale)), scale) === n) {
        return n;
      } else {
        throw Error('ArithmeticException: Rounding needed with the rounding mode being set to RoundingMode.UNNECESSARY');
      }
    }
  }
}

var DecimalFormat = /*#__PURE__*/function () {
  function DecimalFormat() {
    var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var roundingMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : RoundingMode.HALF_UP;

    _classCallCheck(this, DecimalFormat);

    this.config = _objectSpread({}, resolveFormat(format));
    this.roundingMode = roundingMode;
  }

  _createClass(DecimalFormat, [{
    key: "setRoundingMode",
    value: function setRoundingMode(roundingMode) {
      this.roundingMode = roundingMode;
    }
  }, {
    key: "format",
    value: function format(n) {
      var _this$config = this.config,
          maxScale = _this$config.maxScale,
          minScale = _this$config.minScale,
          percent = _this$config.percent,
          length = _this$config.length,
          thousandSeparate = _this$config.thousandSeparate,
          prefix = _this$config.prefix,
          suffix = _this$config.suffix,
          radixPoint = _this$config.radixPoint,
          withSign = _this$config.withSign;
      var number = +n;

      if (isNaN(number)) {
        throw Error('not a valid number');
      }

      number = enlarge(number, Math.log10(percent));

      if (maxScale !== void 0) {
        number = round(number, maxScale, this.roundingMode).toFixed(maxScale);
      } else {
        number = "".concat(number);
      }

      var _number$split = number.split('.'),
          _number$split2 = _slicedToArray(_number$split, 2),
          int = _number$split2[0],
          decimal = _number$split2[1];

      if (length) {
        var intMatch = int.match(/([+-]?)(\d*)/);
        int = intMatch[1] + intMatch[2].padStart(length, 0);
      } else if (int === '0') {
        int = '';
      }

      if (thousandSeparate && thousandSeparate < int.length) {
        // 整数部分如果需要格式化
        int = int.replace(new RegExp("(\\d{1,".concat(thousandSeparate, "})(?=(?:\\d{").concat(thousandSeparate, "})+$)"), 'g'), '$1,');
      }

      if (decimal) {
        decimal = decimal.replace(/0+$/, '').padEnd(minScale, 0);
      }

      number = [int, decimal].join('.');

      if (!radixPoint) {
        number = number.replace(/\.$/, '');
      }

      if (withSign && !number.startsWith('-')) {
        number = "+".concat(number);
      }

      if (number === '') {
        number = 0;
      }

      return "".concat(prefix).concat(number).concat(suffix);
    }
  }]);

  return DecimalFormat;
}();

var RoundingMode = {
  UP: 0,
  DOWN: 1,
  CEILING: 2,
  FLOOR: 3,
  HALF_UP: 4,
  HALF_DOWN: 5,
  HALF_EVEN: 6,
  UNNECESSARY: 7
};
export default DecimalFormat;
export { RoundingMode };